import { type InputHTMLAttributes, forwardRef } from "react";
import { cn } from "./utils/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ type = "text", invalid, className, ...rest }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn("hui-input", invalid && "hui-input--error", className)}
      {...rest}
    />
  )
);

Input.displayName = "Input";
